if (!window.customElements.get("read-more-html")) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.fullContent = this.innerHTML;
      this.maxHeight = this.dataset.maxHeight || '100px';
      this.isExpanded = true;
      this.readMoreLabel = this.dataset.readMoreLabel || 'Read more >>';
      this.readLessLabel = this.dataset.readLessLabel || 'Show less <<';
      this.querySelector(".read-more__toggle").addEventListener("click", () => this.toggleContent());
      this.toggleContent();
    }

    toggleContent() {
      this.isExpanded = !this.isExpanded;
      this.toggleAttribute('expanded', this.isExpanded);
      this.querySelector('.read-more__toggle').textContent = this.isExpanded ? this.readLessLabel : this.readMoreLabel;

    }

  }

  customElements.define("read-more-html", ReadMore);
}